import { FunctionComponent } from 'react';
import styles from './FloatingCookieButton.module.scss';

interface FloatingCookieButtonProps {
  /** Çerez tercih panelini (CookieConsentDialog) açan callback. */
  onClick: () => void;
}

/**
 * Kalıcı "Çerez Tercihlerimi Yönet" düğmesi.
 * Çerez Politikası (Bölüm 7) gereği kullanıcının açık rızasını dilediği zaman
 * geri alabilmesi / tercihlerini değiştirebilmesi için her sayfada erişilebilir
 * bir giriş noktası sağlar.
 */
const FloatingCookieButton: FunctionComponent<FloatingCookieButtonProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={styles.button}
      aria-label="Çerez Tercihlerimi Yönet"
      title="Çerez Tercihlerimi Yönet"
    >
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M12 2.5c-5.25 0-9.5 4.25-9.5 9.5s4.25 9.5 9.5 9.5 9.5-4.25 9.5-9.5c0-.36-.02-.71-.06-1.06a3 3 0 0 1-3.66-3.72A3 3 0 0 1 11.55 3.6c.01-.37.06-.74.15-1.1A9.6 9.6 0 0 0 12 2.5Z"
          fill="currentColor"
          fillOpacity="0.16"
        />
        <path
          d="M12 2.5c-5.25 0-9.5 4.25-9.5 9.5s4.25 9.5 9.5 9.5 9.5-4.25 9.5-9.5c0-.36-.02-.71-.06-1.06a3 3 0 0 1-3.66-3.72A3 3 0 0 1 11.55 3.6c.01-.37.06-.74.15-1.1A9.6 9.6 0 0 0 12 2.5Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        />
        <circle cx="9" cy="10.5" r="1.1" fill="currentColor" />
        <circle cx="13.2" cy="14.6" r="1.1" fill="currentColor" />
        <circle cx="8.4" cy="15" r="0.9" fill="currentColor" />
        <circle cx="15.4" cy="10" r="0.85" fill="currentColor" />
      </svg>
    </button>
  );
};

export default FloatingCookieButton;
